var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-step-wrapper',{attrs:{"questions":_vm.questions,"default-model":_vm.defaultModel,"submit-function":_vm.saveData,"on-success":_vm.onSubmit,"skip-intro":""}})}
var staticRenderFns = []

export { render, staticRenderFns }